export class PoiSelectedEventData {
	globalLocation: { x: number; y: number; z: number } | undefined;
	icon: string | undefined;
	id: number | undefined;
	poiTypeId: number | undefined;
	titles: Record<string, string> | undefined;
	descriptions: Record<string, string> | undefined;
	// Explicit FMS reference for selections coming from search / FMS tree.
	// POIs clicked directly in IVION carry the id in the description instead
	// (marker "skomap:building:<id>" / "skomap:fa:<id>").
	fmsRef?: { type: 'building' | 'fa'; id: number };
}
